var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGrabando(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.53 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}.cls-2{fill:#8c1818;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-grabando") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_64",
    "data-name": "Capa 64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.12,255.12H19.75A19.77,19.77,0,0,1,0,235.36v-106a19.77,19.77,0,0,1,19.75-19.75H167.12a19.78,19.78,0,0,1,19.76,19.75v8.45l15.51-14.37a15.57,15.57,0,0,1,26.14,11.43v95a15.57,15.57,0,0,1-26.14,11.42l-15.51-14.36v8.44A19.78,19.78,0,0,1,167.12,255.12ZM19.75,123a6.39,6.39,0,0,0-6.38,6.39v106a6.39,6.39,0,0,0,6.38,6.39H167.12a6.4,6.4,0,0,0,6.39-6.39v-39l38,35.15a2.19,2.19,0,0,0,3.69-1.61v-95a2.2,2.2,0,0,0-3.69-1.62l-38,35.15v-39a6.4,6.4,0,0,0-6.39-6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.91,216.28a22.46,22.46,0,0,1-22.38-22.42v-23A22.38,22.38,0,0,1,93.1,151.48L113,163a22.39,22.39,0,0,1,0,38.77L93.1,213.25A22.33,22.33,0,0,1,81.91,216.28Zm0-54.45a9.07,9.07,0,0,0-4.51,1.22,8.93,8.93,0,0,0-4.5,7.81v23a9,9,0,0,0,13.52,7.81l19.92-11.5a9,9,0,0,0,0-15.62l-19.92-11.5A9,9,0,0,0,81.91,161.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.08,94.1a6.67,6.67,0,0,1-5.31-10.73,59.71,59.71,0,0,0-.17-72.53,6.68,6.68,0,0,1,10.59-8.15,73.09,73.09,0,0,1,.21,88.78A6.64,6.64,0,0,1,142.08,94.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.48,94.18a6.66,6.66,0,0,1-5.31-2.62,73.08,73.08,0,0,1,.21-89A6.68,6.68,0,0,1,42,10.77a59.72,59.72,0,0,0-.17,72.67,6.68,6.68,0,0,1-5.31,10.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.79,81.36a6.69,6.69,0,0,1-4.45-11.68,30.21,30.21,0,0,0,0-45.17,6.69,6.69,0,1,1,8.89-10,43.59,43.59,0,0,1,0,65.14A6.67,6.67,0,0,1,113.79,81.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.62,81.33a6.67,6.67,0,0,1-4.46-1.71,43.59,43.59,0,0,1,.17-65.08,6.68,6.68,0,0,1,8.87,10,30.22,30.22,0,0,0-.12,45.13,6.68,6.68,0,0,1-4.46,11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.25,68.51a21.42,21.42,0,1,1,21.42-21.42A21.45,21.45,0,0,1,89.25,68.51Zm0-29.47a8.06,8.06,0,1,0,8.06,8.05A8.06,8.06,0,0,0,89.25,39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrabando);
export default __webpack_public_path__ + "static/media/ic-grabando.d9c4445e170f5c12b1a7c9624e0509c0.svg";
export { ForwardRef as ReactComponent };